import {
  UPDATE_MERCHANT_ID,
  FETCH_WALLET_HISTORY_LOG,
  UPDATE_WALLLET_HISTORY_FILTERS,
  UPDATE_WALLLET_HISTORY_PAGINATION,
  WALLET_HISTORY_ASYNC_START,
} from '../types';
import WalletHistory from 'services/wallet-history';
import { showToast } from './toast';
import { setLoading } from './auth';

export const merchantId = (id) => {
  return {
    type: UPDATE_MERCHANT_ID,
    payload: id,
  };
};

export const fetchWalletHistory = (filters) => async (dispatch, getState) => {
  dispatch(setLoading(true));
  dispatch({
    type: WALLET_HISTORY_ASYNC_START,
    subType: 'walletHistory',
  });
  try {
    const {
      common: { user },
    } = getState();

    const { data, ...meta } = await WalletHistory.fetchWalletHistory(
      user?.merchantId,
      filters
    );

    dispatch({
      type: FETCH_WALLET_HISTORY_LOG,
      payload: { data, meta },
      subType: 'walletHistory',
    });
    dispatch(setLoading(false));
  } catch (error) {
    dispatch(setLoading(false));
    dispatch(
      showToast(
        'error',
        'Something went wrong',
        error?.response?.data?.message || 'Error fetching data. Try again.'
      )
    );
  }
};

export const updateWalletHistoryFilter = (filters) => async (dispatch) => {
  dispatch({
    type: UPDATE_WALLLET_HISTORY_FILTERS,
    payload: filters,
    subType: 'walletHistory',
  });
};
export const updateWalletPagination = (page) => async (dispatch) => {
  dispatch({
    type: UPDATE_WALLLET_HISTORY_PAGINATION,
    payload: page,
    subType: 'transactions',
  });
};
